import * as React from "react";
import { cn } from "./utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full resize-y rounded-xl border-2 border-shire-bark/30 bg-white/90 px-4 py-3 font-body text-base shadow-inner backdrop-blur-sm transition-all duration-200 placeholder:text-shire-bark/50 hover:border-shire-bark/50 focus:border-shire-sun focus:outline-none focus:ring-4 focus:ring-shire-sun/20 disabled:cursor-not-allowed disabled:opacity-50 sm:text-lg",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
